"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_CONTRIBUTIONS = exports.CONTRIBUTOR = exports.ALL_CONTRIBUTORS = exports.GENERAL_CONFIG = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.GENERAL_CONFIG = (type) => graphql_tag_1.default `
  ${type} GeneralConfig($id: String!) {
    generalConfig(id: $id) {
      hatch {
        id
        token {
          id
          name
          symbol
          decimals
        }
        reserve
        beneficiary
        contributionToken {
          id
          name
          symbol
          decimals
        }
        minGoal
        maxGoal
        period
        exchangeRate
        vestingCliffPeriod
        vestingCompletePeriod
        supplyOfferedPct
        fundingForBeneficiaryPct
        openDate
        vestingCliffDate
        vestingCompleteDate
        totalRaised
        state
        PPM
      }
      hatchOracle {
        id
        ratio
        scoreToken {
          id
          name
          symbol
          decimals
        }
      }
    }
  }
`;
exports.ALL_CONTRIBUTORS = (type) => graphql_tag_1.default `
  ${type} Contributors($appAddress: String!, $first: Int!, $skip: Int!, $orderBy: String!, $orderDirection: String!) {
    contributors(where: {
      hatchConfig: $appAddress,
      totalValue_gt: 0
    }, first: $first, skip: $skip, orderBy: $orderBy, orderDirection: $orderDirection) {
      id
      account
      totalAmount
      totalValue
    }
  }
`;
exports.CONTRIBUTOR = (type) => graphql_tag_1.default `
  ${type} Contributor($id: ID!) {
    contributor(id: $id) {
      id
      account
      totalAmount
      totalValue
    }
  }
`;
exports.ALL_CONTRIBUTIONS = (type) => graphql_tag_1.default `
  ${type} Contributions($appAddress: String!, $contributor: String!, $first: Int!, $skip: Int!, $orderBy: String!, $orderDirection: String!) {
    contributions(where: {
      appAddress: $appAddress,
      contributor_contains: $contributor
    }, first: $first, skip: $skip, orderBy: $orderBy, orderDirection: $orderDirection) {
      id
      contributor {
        id
      }
      value
      amount
      vestedPurchaseId
      createdAt
    }
  }
`;
//# sourceMappingURL=index.js.map